<template>
  <div class="outer">
    <div class="inner--sides">
      <primary-button
        v-if="showBackToListButton"
        class="btn--sm btn--float"
        @click.native="clickBackToList"
      >
        <span v-html="backToListText"/>
      </primary-button>
      <h3 class="prompt">{{ stakeholderPrompt2 }}</h3>
      <stakeholder-search
        aria-label="Enter text to search lawmakers and policy influencers"
        placeholder="Search lawmakers and policy influencers"/>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import PrimaryButton from "WhoDoYouKnowComponents/buttons/PrimaryButton.vue";
import Routes from "Constants/campaign/whodoyouknow/routeNames";
import StakeholderSearch from "WhoDoYouKnowComponents/StakeholderSearch.vue";
import { isEmpty as _isEmpty } from "lodash";

export default {
  name: "StakeholderSearchWrapper",
  components: {
    PrimaryButton,
    Routes,
    StakeholderSearch
  },
  data() {
    return {
      backToListText: "&#8592; Back to list",
      showRelationshipForm: false
    };
  },
  computed: {
    ...mapState("wdyk", {
      loading: state => state.loading,
      searchTerm: state => state.searchTerm
    }),
    ...mapState("campaign", {
      stakeholderPrompt2: state => state.contentStakeholderSearchPrompt2
    }),
    searchBarEmpty() {
      return _isEmpty(this.searchTerm);
    },
    showBackToListButton() {
      return (
        !this.showRelationshipForm && !this.loading && !this.searchBarEmpty
      );
    }
  },
  inject: {
    stakeholderService: { from: "stakeholderService" },
    eventsBus: { from: "eventsBus" }
  },
  mounted() {
    this.eventsBus.$on("showRelationshipForm", bool => {
      this.showRelationshipForm = bool;
    });
  },
  methods: {
    clickBackToList() {
      this.stakeholderService.clearSearch();
    }
  }
};
</script>
<style>
.outer {
  position: relative;
}
</style>
